import { mergeMap } from 'rxjs/operators/mergeMap';
import { combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { stopSubmit, setSubmitFailed } from 'redux-form';
import { TOGGLE_EDIT_ADDRESS, UPDATE_ADDRESS } from '../actions/screens';
import { openModal, closeModal } from '../redux/modal';
import EditAddressForm from '../components/Address/EditAddressForm';
import { UpdateAddressQuery } from '../graphql/UpdateAddress';
import { catchReduxFormMutationErrors } from './helpers/errors';

const editAddressModalEpic = (action$) =>
  action$.pipe(
    ofType(TOGGLE_EDIT_ADDRESS),
    mergeMap(({ value }) =>
      of(
        openModal({
          content: <EditAddressForm address={value} />,
          label: 'modal',
          closeOnEscape: true,
        })
      )
    )
  );

const handleReduxFormMutationErrors = catchReduxFormMutationErrors('address', {
  'user.updateAddress': 'address',
});

const updateAddressEpic = (action$, state$, { apolloClient }) =>
  action$.pipe(
    ofType(UPDATE_ADDRESS),
    map((val) => of(val)),
    switchMap((val) =>
      val.pipe(
        mergeMap(({ value: { id, address } }) =>
          apolloClient.mutate({
            mutation: UpdateAddressQuery,
            variables: { id, address },
          })
        ),
        handleReduxFormMutationErrors,
        mergeMap(({ errorMap = {} }) => {
          if (!Object.keys(errorMap).length) {
            return of(closeModal());
          }
          return of(
            stopSubmit('address', errorMap),
            setSubmitFailed('address', Object.keys(errorMap))
          );
        })
      )
    )
  );

const editAddressEpic = combineEpics(editAddressModalEpic, updateAddressEpic);

export { editAddressModalEpic, updateAddressEpic };

export default editAddressEpic;
